import { FC, PropsWithChildren } from 'react';
import * as S from './styles';

type SidebarButtonWithArrowProps = PropsWithChildren & {
  'data-testid'?: string;
  onClick: () => void;
};

export const SidebarButtonWithArrow: FC<SidebarButtonWithArrowProps> = ({
  children,
  'data-testid': dataTestId,
  onClick,
}) => {
  return (
    <S.SublistButtonWrapper>
      <S.SublistButton data-testid={dataTestId} onClick={onClick}>
        {children}
        <S.ButtonIcon />
      </S.SublistButton>
    </S.SublistButtonWrapper>
  );
};
